var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PublicShare_div"},[_c('div',{staticClass:"share_div_box",attrs:{"id":"share-2"}})])
}]

export { render, staticRenderFns }